import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchListFilters } from '../../redux/slice/DeviceManagementSlice';
import { setPageTitle } from '../../redux/slice/PageTitleSlice';

import ChargingScheduleChart from './components/ChargingScheduleChart';
import ConnectorStatusChart from './components/ConnectorStatusChart';
import DashboardCards from './components/DashboardCards';
import DashboardMap from './components/DashboardMap';
import DeviceDurationChart from './components/DeviceDurationChart';
import DeviceStatus from './components/DeviceStatus';
import DeviceUtilizationChart from './components/DeviceUtilization';
import RevenuePowerConsumedChart from './components/RevenuePowerConsumedChart';
import StationAlertsChart from './components/StationAlertsChart';
import StationOverview from './components/StationOverview';
import StationPerformanceChart from './components/StationPerformanceChart';

/**
 * Dashboard component
 */
function Dashboard() {
  const dispatch = useAppDispatch();
  const { filters, filterListLoading } = useAppSelector((s) => s.device);

  useEffect(() => {
    const filterWithOutSearchBy = filters.filter((eachFilter) => eachFilter.key !== 'searchBy');
    if (filterWithOutSearchBy.length === 0 && !filterListLoading) {
      dispatch(fetchListFilters());
    }
  }, []);

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: '',
        // icon: <FacilityIcon />,
        // count: totalResults,
      }),
    );
  }, []);

  return (
    <div className="dashboard-wrap">
      <DashboardCards />
      <div className="performance-connector-device-status">
        <StationPerformanceChart />
        <ConnectorStatusChart />
        <DeviceStatus />
      </div>
      <StationOverview />
      <div className="revenue-station-alert-wrap">
        <RevenuePowerConsumedChart />
        <StationAlertsChart />
      </div>
      <div className="map-bar-chart">
        <DashboardMap />
        <ChargingScheduleChart />
      </div>
      <div className="map-bar-chart">
        <DeviceUtilizationChart />
        <DeviceDurationChart />
      </div>
    </div>
  );
}

export default Dashboard;
